import React, { useState } from 'react';
import { Modal, Form, Input, Select, Space, Button } from 'antd';
import { CloudOutlined } from '@ant-design/icons';

const { Option } = Select;

const AddDomainModal = ({ visible, onCancel, onAdd, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onAdd(values);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title="Add New Domain"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={520}
    >
      <Form
        form={form}
        layout="vertical"
        className="add-domain-form"
      >
        <Form.Item
          name="domain"
          label="Domain Name"
          rules={[
            { required: true, message: 'Please enter domain name' },
            { type: 'string', pattern: /^[a-zA-Z0-9][a-zA-Z0-9-_.]+\.[a-zA-Z]{2,}$/, message: 'Please enter a valid domain' }
          ]}
        >
          <Input 
            placeholder="e.g. www.example.com"
            prefix={<CloudOutlined style={{ color: '#bfbfbf' }} />}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
        >
          <Input.TextArea 
            placeholder="Add a description for this domain (optional)"
            rows={3}
          />
        </Form.Item>

        <Form.Item
          name="defaultEndpoint"
          label="Default Endpoint"
          rules={[{ required: true, message: 'Please select default endpoint' }]}
        >
          <Select placeholder="Select default endpoint">
            <Option value="aws-sg">AWS Singapore</Option>
            <Option value="aws-jp">AWS Japan</Option>
            <Option value="gcp-sg">GCP Singapore</Option>
          </Select>
        </Form.Item>

        <Form.Item className="form-actions">
          <Space size="middle" style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSubmit} loading={loading}>
              Add Domain
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDomainModal;
